const ButtonComponent = ({ value, onClick, disabled }) => {
    return (
      <button
       className={`bi-custom-button 
          ${disabled ? "bi-disabled-button" : ""}`}
        onClick={onClick}
        disabled={disabled}>
        {value}
      </button>
    )
  }
  
  export default ButtonComponent